<template>
    <div class="AmazonBalance-container">
        <div class="select-box">
            <div class="select-item">
                <div class="label">
                    店铺：
                </div>
                <el-input placeholder="请输入店铺" v-model="storeName" clearable></el-input>
            </div>
            <el-button type="primary" @click="getTable">查询</el-button>
            <el-button type="primary" @click="syncAll">同步所有</el-button>

            <div class="tip">
                余额合计：{{ totalBalance }} USD
            </div>
        </div>
        <el-table :data="tableData" border stripe style="width: 100%" height="700" v-loading="loading">
            <el-table-column prop="shopName" label="店铺" align="center"></el-table-column>
            <el-table-column label="余额" align="left">
                <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.marketplaces" :key="index">
                        {{item.marketplace }} : {{item.balance}} {{ item.currency }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="createdAt" label="拉取时间" align="center"></el-table-column>
            <el-table-column prop="amazonOrderId" label="操作" width="180" align="center">
                <template slot-scope="scope">
                    <el-popover placement="left-start"  trigger="click"
                        >
                        
                        <div class="sync-popover-content">
                            <el-date-picker v-model="syncDateRange" type="daterange" range-separator="至"
                                start-placeholder="开始日期" value-format="yyyy-MM-dd HH:mm:ss" end-placeholder="结束日期" :append-to-body="false"
                                class="custom-date-picker">
                            </el-date-picker>
                            <el-button type="text" @click="syncOne(scope.row)" :loading="scope.row.loading"
                                class="sync-btn">
                                同步
                            </el-button>
                        </div>

                        <el-button slot="reference" type="text">同步</el-button>
                    </el-popover>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { ajaxGet, ajaxPost, Baseurl } from '@/api/api/api.js';
import { getTableHeader, formatDate } from '@/assets/js/common.js'
import axios from 'axios';
export default {
    name: '',
    components: {},
    props: {},
    data() {
        return {
            loading: false,
            tableData: [],
            storeName: '',
            rateMap:{},
            totalBalance: 0,
            syncDateRange: [],
        };
    },
    async created() {
        await this.getRate();
        this.getTable();
    },
    mounted() {},
    watch: {},
    computed: {},
    methods: {
        async getRate(){
            const api = Baseurl + 'rateController/getAllRate';
            const res = await ajaxGet(api)
            if(res.data.code == 200){
                const d = res.data.data;
                const obj = {}
                for(let i = 0; i < d.length; i++){
                    const item = d[i];
                    obj[item.currencyCode] = item.exchangeRate;
                }
                this.rateMap = obj;
            }else{
                this.$message.error(res.data.message);
            }
        },
        getTable(){
            this.loading = true;
            let api = Baseurl + 'amazonBalance/latest';
            if(this.storeName){
                api = Baseurl + 'amazonBalance/latest?shopName=' + this.storeName;
            }
            ajaxGet(api).then(res => {
                if(res.data.code == 200){
                    const data = res.data.data;
                    const obj = {};
                    let total = 0;
                    const cnyToUsdRate = this.rateMap['USD']; // 根据你实际存放位置调整
                    for(let i = 0; i < data.length; i++){
                        const item = data[i];
                        if(!obj[item.shopName]){
                            obj[item.shopName] = [];
                        }
                        const balance = Number(item.balance || 0);
                        let usdVal;
                        if (item.currency === "USD") {
                            usdVal = balance;
                        } else {
                            // 外币 → CNY
                            const cnyVal = balance * Number(this.rateMap[item.currency]);
                            // CNY → USD：CNY / (1USD等于多少CNY)
                            const usdExchange = Number(this.rateMap["USD"]); // 6.7803
                            usdVal = cnyVal / usdExchange;
                        }
                        total += usdVal;
                        obj[item.shopName].push(item);
                    }
                    this.totalBalance = total.toFixed(2);
                    const arr = [];
                    for(let key in obj){
                        const item = obj[key];
                        arr.push({
                            shopName: key,
                            sid: item[0].sid,
                            createdAt: formatDate(item[0].createdAt),
                            marketplaces: item,
                        })
                    }
                    this.tableData = arr;
                }else{
                    this.$message.error(res.data.message);
                }
                this.loading = false;
            })
        },
        syncAll(){
            this.loading = true;
            axios.post("https://iadcamkcstdu.xiaomiqiu.com/api/amazon/sync/transactionAndBalance", {
                startTime: this.getUtcTimeBeforeXDays(45),
                endTime: this.getCurrentUtcTime()
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('同步成功');
                    this.getTable();
                } else {
                    this.$message.error(res.data.message);
                }
                this.loading = false;
            })
        },
        syncOne(row){
            this.$set(row, 'loading', true);
            let startTime = '';
            let endTime = '';

            // 判断用户是否在 el-date-picker 中选择了日期
            if (this.syncDateRange && this.syncDateRange.length === 2) {
                const start = new Date(this.syncDateRange[0]);
                const end = new Date(this.syncDateRange[1]);

                end.setHours(23, 59, 59, 999);
                startTime = this.formatUtcDate(start);
                endTime = this.formatUtcDate(end);
            } else {
                // 没选日期时，使用你原有的默认 UTC 时间逻辑
                startTime = this.getUtcTimeBeforeXDays(45);
                endTime = this.getCurrentUtcTime();
            }

            // 组装请求参数
            const params = {
                startTime: startTime,
                endTime: endTime,
                sid: row.sid,
            };
            axios.post("https://iadcamkcstdu.xiaomiqiu.com/api/amazon/sync/transactionAndBalance", params).then(res=>{
                if(res.data.code == 200){
                    this.$message.success('同步成功');
                    this.getTable();
                }else{
                    this.$message.error(res.data.message);
                }
                this.$set(row, 'loading', false);
            })
        },

        formatUtcDate(date) {
            const pad = n => String(n).padStart(2, '0');
            const year = date.getUTCFullYear();
            const month = pad(date.getUTCMonth() + 1);
            const day = pad(date.getUTCDate());
            const hour = pad(date.getUTCHours());
            const minute = pad(date.getUTCMinutes());
            const second = pad(date.getUTCSeconds());
            return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        },

        /**
         * 获取当前UTC格林威治时间
         * @returns {string} yyyy-MM-dd HH:mm:ss
         */
        getCurrentUtcTime() {
            const now = new Date();
            return this.formatUtcDate(now);
        },
        getUtcTimeBeforeXDays(x) {
            const now = new Date();
            // 复制一份日期，避免修改原对象
            const targetDate = new Date(now);
            // 基于UTC日期做减法，自动处理跨月/跨年
            targetDate.setUTCDate(targetDate.getUTCDate() - x);
            return this.formatUtcDate(targetDate);
        }

    },
};
</script>
<style lang="scss" scoped>
.select-box {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    align-items: center;

    .select-item {
        display: flex;
        align-items: center;
        margin-right: 20px;

        .label {
            width: 80px;
            text-align: right;
            margin-right: 10px;
            white-space: nowrap;
        }
    }
    .tip{
        margin-left: 30px;
        font-size: 16px;
    }
    
}
/* 容器 flex 居中对齐 */
.sync-popover-content {
    display: flex;
    align-items: center;
    gap: 12px;
    line-height: 1;
    /* 消除默认行高导致的上下偏移 */
}

/* 日期组件内部文字及“至”字对齐修正 */
/deep/ .custom-date-picker.el-range-editor {
    display: inline-flex;
    align-items: center;
}

/deep/ .el-date-editor .el-range-separator {
    height: auto !important;
}

/deep/ .el-input__icon {
    display: flex;
    align-items: center;
}

/* 强行修正内部文字与图标居中 */
/deep/ .custom-date-picker .el-range-input,
/deep/ .custom-date-picker .el-range-separator,
/deep/ .custom-date-picker .el-input__icon {
    line-height: 32px !important;
    /* 跟日期框高度一致（默认是 32px/40px） */
    height: 100%;
    vertical-align: middle;
}

/* 同步按钮补齐垂直居中 */
.sync-btn {
    padding: 0;
    line-height: 1;
}
</style>